<script>
import Drawer from "@/components/drawer";
import Swal from "sweetalert2";
import MultiSelect from "vue-multiselect";

// Custom Components
import PageHeader from "@/components/page-header";
import HotelMasterData from "@/components/superAdmin/IOTLock/HotelMasterData.vue";

import UserService from "@/helpers/APIService/user.service";
import errorHandler from "@/helpers/errorHandler";
import Middleware from "@/helpers/middlewares";
import appConfig from "@/app.config";

export default {
  page: {
    title: "Master Data",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  data() {
    return {
      title: "List Of Hotel Master Data",
      isLoading: false,
      table: {
        tableData: [],
        size: 100,
        next: null,
        previous: null,
      },
      filters: {
        hotel: { text: "All", value: "all" },
        status: "all",
      },
      isHotelDataAddOrUpdate: false,
      isEdit: false,
      hotelMasterDataId: null,
      hotelMasterData: null,
      hotels: [],
      isChangeFilterValue: false,
      isApplyFilter: false,
    };
  },
  computed: {
    hotelMasterDataProps() {
      return {
        hotelMasterDataId: this.hotelMasterDataId,
        isEdit: this.isEdit,
        hotelMasterData: this.hotelMasterData,
      };
    },
  },
  components: {
    PageHeader,
    Drawer,
    MultiSelect,
    HotelMasterData,
  },
  mounted() {
    this.getHotelMasterList();
    this.getHotels();
  },
  methods: {
    // Method is used to get hotel list
    async getHotels() {
      if (localStorage.hotels) {
        this.hotels = JSON.parse(atob(localStorage.getItem("hotels")));
      } else {
        this.hotels = await Middleware.hotelList();
      }
    },
    // Method is used to get hotel master data list
    async getHotelMasterList(query = "") {
      this.isLoading = true;
      try {
        const response = await UserService.getHotelMasterList(query);
        if (response) {
          this.table.tableData = response;
          this.isLoading = false;
        }
      } catch (error) {
        this.isLoading = false;
        errorHandler(error);
      }
    },
    // Method is used to handle drawer
    handleHotelMasterDataDrawer(isEdit) {
      if (typeof isEdit !== "boolean") {
        this.isEdit = false;
        this.hotelMasterDataId = null;
        this.hotelMasterData = null;
      }
      this.isHotelDataAddOrUpdate = !this.isHotelDataAddOrUpdate;
    },
    // Method is use update and add new guest in guest list table
    handleSubmit({ data, isEdit }) {
      if (isEdit) {
        this.table.tableData = this.table.tableData.map((item) => {
          if (item.id == data.id) {
            item = data;
          }
          return item;
        });
      } else {
        this.table.tableData.push(data);
      }
      this.isEdit = false;
      this.hotelMasterDataId = null;
      this.gateway = null;
      this.handleHotelMasterDataDrawer();
      Middleware.notification(
        `${isEdit ? "Updated successfully !!" : "Added successfully !!"}`,
        "success"
      );
    },
    // Method is used to edit gateway
    editGateway(data) {
      this.isEdit = true;
      this.hotelMasterData = data;
      this.hotelMasterDataId = data.id;
      this.handleHotelMasterDataDrawer(this.isEdit);
    },
    // Method is used to change status
    changeStatus(data) {
      let formData = new FormData();
      formData.append("is_active", data.is_active);
      UserService.editHotelBasedMasterData(data.id, formData)
        .then(() => {
          Middleware.notification("Successfully changed !!", "success");
        })
        .catch((error) => {
          errorHandler(error);
        });
    },
    // Method is used to delete gateway
    deleteGateway(hotel_master_data_id) {
      Swal.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#238dfa",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: "Yes, delete it!",
      }).then((result) => {
        if (result.value) {
          UserService.deleteHotelMasterData(hotel_master_data_id)
            .then(() => {
              this.table.tableData = this.table.tableData.filter(
                (item) => item.id !== hotel_master_data_id
              );
              Middleware.notification("Successfully deleted !!", "danger");
            })
            .catch((error) => {
              errorHandler(error);
            });
        }
      });
    },
    // Method is used to handle status based filter
    handleStatusFilter() {
      this.isChangeFilterValue = true;
    },
    // Method is used to apply filter
    applyFilter() {
      if (this.isApplyFilter) {
        this.filters = {
          hotel: { text: "All", value: "all" },
          status: "all",
        };
        this.isApplyFilter = false;
        return this.getHotelMasterList();
      }
      if (this.isChangeFilterValue) {
        this.isApplyFilter = true;
        let filter = "";
        if (this.filters.hotel.value !== "all") {
          filter += `?hotel=${this.filters.hotel.value}`;
        }
        if (this.filters.status !== "all") {
          filter += `${filter == "" ? "?" : "&"}is_active=${
            this.filters.status
          }`;
        }
        this.getHotelMasterList(filter);
      }
    },
  },
};
</script>

<template>
  <div>
    <PageHeader
      :title="title"
      text="Add New"
      :isButton="true"
      :action="handleHotelMasterDataDrawer"
    />
    <div class="card">
      <div class="card-body">
        <div class="row">
          <!-- Filter gateway by hotel -->
          <div class="col-xl-3 col-lg-5 col-md-6 col-sm-8">
            <MultiSelect
              class="mb-2"
              v-model="filters.hotel"
              :options="hotels"
              :show-labels="false"
              placeholder="Select Hotel"
              track-by="value"
              label="text"
              name="hotels"
              :allow-empty="false"
              @close="handleStatusFilter()"
            />
          </div>
          <!-- Filter gateway by hotel -->
          <div class="col-xl-2 col-lg-3 col-md-4 col-sm-4">
            <select
              name="is_active"
              id="is_active"
              class="form-control mb-2"
              v-model="filters.status"
              placeholder="by is active"
              @change="handleStatusFilter"
            >
              <option value="all">All</option>
              <option value="true">Active</option>
              <option value="false">Inactive</option>
            </select>
          </div>
          <div class="col-xl-2 col-lg-3 col-md-2">
            <b-button
              variant="primary"
              class="float-end float-md-start mb-2"
              @click="applyFilter"
              >{{ !isApplyFilter ? "Apply Filter" : "Clear Filter" }}</b-button
            >
          </div>
        </div>
        <div class="table-responsive mb-0">
          <v-table
            :data="table.tableData"
            class="table table-hover mb-0"
            ref="my-table"
          >
            <thead class="table-light" slot="head">
              <tr>
                <v-th sortKey="hotel_key">Hotel Key</v-th>
                <v-th sortKey="admin_key">Admin Key</v-th>
                <th>Firmware Version</th>
                <v-th sortKey="hotel.name">Hotel</v-th>
                <th>Updated by</th>
                <th>Last Config</th>
                <th>Status</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody
              class="infinite-list"
              slot="body"
              slot-scope="{ displayData }"
              v-if="!isLoading && table.tableData.length !== 0"
            >
              <tr v-for="(item, index) in displayData" :key="index">
                <td @click="editGateway(item)">
                  {{ item.hotel_key !== null ? item.hotel_key : "-" }}
                </td>
                <td @click="editGateway(item)">
                  {{ item.admin_key !== null ? item.admin_key : "-" }}
                </td>
                <td @click="editGateway(item)">
                  {{
                    item.firmware_version !== null ? item.firmware_version : "-"
                  }}
                </td>
                <td @click="editGateway(item)">
                  {{ item.hotel !== null ? item.hotel.name : "-" }}
                </td>
                <td @click="editGateway(item)">
                  {{ item.updated_by !== null ? item.updated_by : "-" }}
                </td>
                <td @click="editGateway(item)">
                  {{
                    global_format_date_and_time_custom(
                      item.updated_at,
                      "YYYY-MM-DD hh:mm A"
                    )
                  }}
                </td>
                <td>
                  <div class="form-check form-switch my-1" slot="is_active">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      v-model="item.is_active"
                      @change="
                        changeStatus({
                          id: item.id,
                          is_active: item.is_active,
                        })
                      "
                    />
                  </div>
                </td>
                <td>
                  <i
                    class="fas fa-pencil-alt text-success mx-1"
                    v-b-popover.hover="'Edit recored'"
                    id="edit"
                    @click="editGateway(item)"
                  ></i>
                  <i
                    class="mdi mdi-trash-can text-danger fs-5 mx-1"
                    v-b-popover.hover="'View card details'"
                    @click="deleteGateway(item.id)"
                  ></i>
                </td>
              </tr>
            </tbody>
            <tbody slot="body" v-else-if="isLoading">
              <tr v-for="item in 10" :key="item">
                <td class="placeholder-glow" v-for="no in 8" :key="no">
                  <span class="placeholder w-100 placeholder-lg"></span>
                </td>
              </tr>
            </tbody>
            <tbody slot="body" v-else>
              <tr>
                <td colspan="9" class="text-center">
                  <img
                    src="@/assets/images/empty.svg"
                    class="img-fluid"
                    alt=""
                  />
                  <p>
                    <span class="text-secondary">No Data Found</span>
                  </p>
                </td>
              </tr>
            </tbody>
          </v-table>
        </div>
      </div>
    </div>

    <!-- Drawer -->
    <Drawer
      @close="handleHotelMasterDataDrawer"
      :align="'right'"
      :closeable="true"
      :maskClosable="true"
      :zIndex="1002"
    >
      <div v-if="isHotelDataAddOrUpdate">
        <HotelMasterData
          :currentProps="hotelMasterDataProps"
          @submitted="handleSubmit"
          @cancelSubmit="handleHotelMasterDataDrawer()"
        ></HotelMasterData>
      </div>
    </Drawer>
  </div>
</template>
